<template>
  <v-container fluid>
    <!-- DESKTOP -->
    <v-row class="d-none d-lg-block mx-16 px-16">
      <v-col cols="12">
        <span class="primary--text text-h1 font-weight-bold">{{ $t('technologies.title') }}</span>
      </v-col>
    </v-row>

    <!-- MOBILE -->
    <v-row class="d-lg-none">
      <v-col cols="12">
        <span class="primary--text text-h4 font-weight-bold">{{ $t('technologies.title') }}</span>
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0">
      <v-col cols="12">
        <div class="ddt-carousel-guard">
        <Carousel
            ref="carousel"
            :items-to-show="3"
            :wrap-around="true"
            snap-align="center"
            :autoplay="3000"
            :pause-autoplay-on-hover="true"
            :transition="600"
            :mouse-drag="true"
            :touch-drag="true"
            :breakpoints="breakpoints"
            class="ddt-carousel"
            :style="{'--vc-slide-gap':'0px'}"
            >
            <Slide v-for="(src, i) in images" :key="i">
                <div class="ddt-card">
                    <v-img :src="src" contain height="310" width="310" class="pa-4" />
                </div>
            </Slide>
        </Carousel>
        </div>
      </v-col>

      <v-col cols="12" class="mt-2 text-center ma-0 pa-0 mb-8">
        <v-btn class="mx-6" fab dark small color="primary" @click="goLeft">
          <v-icon dark color="white">mdi-arrow-left-thick</v-icon>
        </v-btn>
        <v-btn class="mx-6" fab dark small color="primary" @click="goRight">
          <v-icon dark color="white">mdi-arrow-right-thick</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'

export default {
  name: 'Technologies',
  components: { Carousel, Slide },
  data () {
    return {
      breakpoints: {
        0:   { itemsToShow: 1.4 }, // mobile pequeno (pequeno “peek” do slide seguinte)
        480: { itemsToShow: 2 },
        768: { itemsToShow: 3 },
        992: { itemsToShow: 4 },
        1280:{ itemsToShow: 5 }
      },
      images: [
        require('../assets/technologies/laravel.png'),
        require('../assets/technologies/javascript.png'),
        require('../assets/technologies/vuejs.png'),
        require('../assets/technologies/reactjs.png'),
        require('../assets/technologies/python.jpg'),
        require('../assets/technologies/php.png'),
        require('../assets/technologies/sql.png'),
        require('../assets/technologies/mssql.png'),
        require('../assets/technologies/mysql.png'),
        require('../assets/technologies/git.png'),
        require('../assets/technologies/azure.png'),
        require('../assets/technologies/mongo.png'),
        require('../assets/technologies/docker.png'),
        require('../assets/technologies/digital_ocean.png')
      ]
    }
  },
  methods: {
    goLeft () {
        const c = this.$refs.carousel
        if (!c) return
        // tenta a API pública, depois fallback para data.nav
        if (typeof c.prev === 'function') c.prev()
        else if (c.data?.nav?.prev) c.data.nav.prev()
    },
    goRight () {
        const c = this.$refs.carousel
        if (!c) return
        if (typeof c.next === 'function') c.next()
        else if (c.data?.nav?.next) c.data.nav.next()
    }
  },
  computed:{    
    carouselConfig(){
        return {
            height: 200,
            itemsToShow: 3.5,
            wrapAround: true,
        }
    },
  }
}
</script>

<style>
/* cartão branco com sombra como o antigo */
.ddt-card{
  height: 310px;
  width: 310px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 12px 24px rgba(0,0,0,.18), 0 2px 6px rgba(0,0,0,.08);
  display:flex; align-items:center; justify-content:center;
}

/* um pouco mais compacto em telemóvel */
@media (max-width: 600px){
  .ddt-card{ height:260px; width:260px; }
}

/* —— efeito 3D —— */
.carousel__viewport{
  perspective: 1600px;
  overflow: visible;            /* deixa sombras “sair” do contentor */
}
.carousel__track{
  transform-style: preserve-3d;
}

/* transições suaves */
.carousel__slide{
  transition:
    transform 500ms cubic-bezier(.22,.61,.36,1),
    opacity   500ms cubic-bezier(.22,.61,.36,1),
    filter    500ms cubic-bezier(.22,.61,.36,1);
  will-change: transform, opacity, filter;
  opacity: .65;
  transform: translateX(10px) rotateY(-14deg) translateZ(-90px) scale(.88);
  /* sombra base (mais suave nos “laterais”) */
  filter: drop-shadow(0 10px 18px rgba(0,0,0,.18));
}

/* slide imediatamente à esquerda do ativo */
.carousel__slide--prev{
  opacity: .9;
  transform: rotateY(-10deg) translateX(-6%) translateZ(-45px) scale(.94);
}

/* slide ativo (no centro) */
.carousel__slide--active{
  opacity: 1;
  transform: rotateY(0) translateZ(0) scale(1);
  filter: drop-shadow(0 18px 32px rgba(0,0,0,.22));
}

/* slide imediatamente à direita do ativo */
.carousel__slide--next{
  opacity: .9;
  transform: rotateY(10deg) translateX(6%) translateZ(-45px) scale(.94);
}

/* os restantes para a direita */
.carousel__slide--next ~ .carousel__slide{
  opacity: .65;
  transform: translateX(-10px) rotateY(14deg) translateZ(-90px) scale(.88);
}

/* gap e centragem a lembrar o antigo */
.ddt-carousel{ --vc-slide-gap: 24px; }


/* impede que o conteúdo alargado crie scroll horizontal */
.ddt-carousel-guard{
  overflow-x: hidden;         /* ou clip */
  position: relative;
  /* dá um pequeno “respiro” para as sombras não serem cortadas */
  padding-inline: 16px;
  margin-inline: -16px;       /* mantém o alinhamento com o resto do layout */
}

/* manténs isto para as sombras 3D */
.carousel__viewport{
  perspective: 1600px;
  overflow: visible;
}
</style>
